<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
	<v-card
		flat
		outlined
	>
		<v-card-title class="pt-1">
			<h2 class="titlelabel">効果の高いプレスリリース</h2>
		</v-card-title>
		<v-card-text
			class="pb-0"
		>
			<v-row v-for="release in release_list" :key="release.no" class="my-1" style="margin:0 0 20px!important">
				<v-col cols="4" v-if="release.no == 1">
                      <v-img
                        :src="`https://search.qlipper.jp/cont/docimg?doc_id=` + release.doc_id"
                        :aspect-ratio="16/9"
                        class="grey lighten-2"
                        style="text-align:end;"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
				</v-col>
				<v-col cols="1" class="py-2 px-0" v-else>
                      <v-img
                        :src="`https://search.qlipper.jp/cont/docimg?doc_id=` + release.doc_id"
                        :aspect-ratio="16/9"
                        class="grey lighten-2"
                        style="text-align:end;"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
				</v-col>
				<v-col class="py-2 pl-0" v-if="release.no == 1">
				<v-card
					flat
					outlined
				>
					<v-card-text>
					<v-row>
						<v-col class="px-2">
							<p class="cmpname">{{ release.company_name }}</p>
							<a :href="decodeURIComponent(release.doc_url)" target="_blunk"><h2 class="reltitle">{{ release.doc_title }}</h2></a>
						</v-col>
					</v-row>
					<v-row class="my-0 py-2">
						<v-col>{{decodeURIComponent(release.doc_url)}}</v-col>
					</v-row>
					<v-row class="my-0" >
						<v-col class="py-2 pl-3 pr-0" cols="5">
							<span class="mediainfo">
								{{ release.media_title }}
								<p>{{ release.doc_date }}</p>
							</span>
						</v-col>
						<v-col class="py-1 px-2">
							<span class="docdata">{{Number(release.ssum_pv).toLocaleString()}}</span>
							<p class="helptxt"><a href="javascript:void(0)"><v-icon color="#284C79" dense>mdi-help-box-outline</v-icon>仮想ページビューとは？</a></p>
						</v-col>
					</v-row>
					</v-card-text>
				</v-card>
				</v-col>
				<v-col class="py-1" cols="11" v-else>
					<span class="mediainfo">
					<a :href="decodeURIComponent(release.doc_url)" target="_blunk"><span class="ranktitle_sub">{{ release.doc_title }}</span></a>
					<p>{{ release.company_name }}<span style="font-weight:bold;margin-left:10px;margin-right:10px">{{ release.media_title }}</span>{{ release.doc_date }}</p>
					</span>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions
			class="pt-0"
		>
			<v-spacer />
			<v-btn
				to="/neta"
				class="mr-2"
				text
				dense
			>
				<v-icon color="red" class="mr-2">mdi-trending-up</v-icon>リリーストレンドへ
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
export default {
	data : function(){
		return {
			release_list : [],
		};
	},
	created : async function(){
        var params = new URLSearchParams();
        await axios.post("https://qlipper.jp/api/release/get_release_rank",params)
        .then(response => {
            this.release_list = response.data;
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
	},
}
</script>
<style>
.reltitle{
	margin: 0;
}
.ranktitle_sub {
    display: flex;
    align-items: center;
    height: 60%;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.cmpname{
	font-size   : 1.3rem;
	font-weight : bold;
	margin : 0 0 5px 0!important;
	color  : black;
}
.docdata{
	font-size : 2.5rem;
	font-weight : bold;
	color  : black;
}

.mediainfo{
	font-size : 1.7rem;
	font-weight : bold;
	color  : black;
}
.mediainfo p{
	font-size : 1.2rem;
	font-weight : normal;
	color  : black;
	margin : 0;
}

.helptxt{
	font-size:1.2rem;
	font-weight : bold;
    margin : 0 0 3px 0!important;
}
.helptxt a{
	color : #284C79!important;
}
</style>
